export enum VipSupportServices {
  telegram = 'telegram',
  whatsapp = 'whatsapp',
  none = 'none',
}
